import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from "@mui/material/Container";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import MainDrawer from "./MainDrawer";
import Footer from "./Footer";

const MainLayout = (props) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

    return (
        <Box sx={{ display: 'flex', boxSizing: 'border-box' }}>
            <CssBaseline />

            {/* Mobile-only AppBar with hamburger */}
            <AppBar
                position="fixed"
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="abrir menú"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        La Cabaña
                    </Typography>
                </Toolbar>
            </AppBar>

            <MainDrawer
                mobileOpen={mobileOpen}
                onClose={handleDrawerToggle}
                onLogout={props.onLogout}
            />

            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) => theme.palette.background.default,
                    flexGrow: 1,
                    width: { xs: '100%', sm: 'calc(100% - 240px)' },
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Container maxWidth={false} sx={{
                    flex: '1 0 auto',
                    pt: { xs: 9, sm: 4 },     // pt mayor en xs por la AppBar fija
                    px: { xs: 2, sm: 3 },
                    pb: { xs: 3, sm: 4 },
                }}>
                    {props.children}
                </Container>
                <Footer />
            </Box>
        </Box>
    );
};

export default MainLayout;
